/**
 * Whether the signed-in account changed since the last one seen (3 Nov 2026). The app's cached server
 * data (documents, lists, the open document) belongs to the account that fetched it; signing out and in
 * as someone else on the same device happens without a page load, and the next account saw the last
 * one's open document, and its editor tried to save it.
 *
 * `previous` is undefined until the session first settles: nothing was cached for anyone yet. Null is
 * "signed out".
 */
export function accountChanged(previous: string | null | undefined, next: string | null): boolean {
    return previous !== undefined && previous !== next
}
